import Promise from 'bluebird';
import React from 'react';
import _ from 'lodash';

import { AjaxSelectInput } from 'components/forms/form-elements';
import { PRAECE_ROLES, SELECT_PAGE_SIZE } from 'constants';
import { alerts } from 'modules/alerts/actions';
import Person from 'services/data/person';


export default class PersonSelect extends React.Component {
  static propTypes = {
  };

  getData(term, vals) {
    const ids = _.compact(_.concat([], vals));

    const params = {
      where: { role: { not: { in: PRAECE_ROLES } } },
      sort: 'lastName',
      limit: SELECT_PAGE_SIZE
    };

    if (term) params.where.search = term;

    return Promise.all([
      Person.find(params),
      ids && ids.length ? Person.find({ where: { id: { in: ids } } }) : []
    ])
      .then(([search, values]) => _.unionBy(search, values, 'id'))
      .then((people) => _.map(people, formatPerson))
      .catch(alerts.catchError);
  }

  render() {
    return (
      <AjaxSelectInput
        {..._.omit(this.props, ['person'])}
        labelKey="fullname"
        valueKey="id"
        loadOptions={this.getData}
      />
    );
  }
}

/**
 * Select looks at the "text" property on objects to determine what to display,
 * so this function sets text on people
 */
function formatPerson(person) {
  return {
    fullname: person ? Person.fullName(person) : null,
    ...person
  };
}
